<template>
  <div class="d-flex align-items-center">
    <b-carousel id="carousel-no-animation" no-animation controls indicators :interval="0">
      <b-carousel-slide v-for="(quote, index) in quotes" :key="index">
        <template #img>
          <div class="quote-block d-flex justify-content-center align-items-center py-4">
            <quote-block
              :quote-text="quote.quote"
              :quote-name="quote.author_name"
              :quote-detail="quote.author_title"
              :quote-image="quote.author_image ? quote.author_image.url : null"
              :quote-image-alt-text="quote.alt_text"
              :quote-reference="quote.reference"
              :is-dark-bg="isDarkBg"
            />
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import QuoteBlock from "../../stream-page/blocks/QuoteBlock";
export default {
  name: "QuoteCarouselBlock",
  components: { QuoteBlock },
  props: {
    id: Number,
    quotes: Array,
    isDarkBg: Boolean,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .carousel-indicators {
    margin: 0;
    & li {
      height: 8px;
      width: 8px;
      border-radius: 50%;
      background-color: $color-orange;
    }
  }
  .carousel {
    padding: 0 50px;
    width: 100%;
  }
  .carousel-control-prev,
  .carousel-control-next {
    opacity: 1;
    width: 50px;
  }
  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    border: 1px solid $color-orange;
    border-radius: 100%;
    width: 24px;
    height: 24px;
    position: relative;
    background: none;

    &:before,
    &:after {
      content: "";
      width: 1px;
      height: 6px;
      display: block;
      transform: rotate(45deg);
      background-color: $color-orange;
      position: absolute;
      left: 10px;
      top: 6px;
    }
    &:after {
      top: 10px;
      transform: rotate(-45deg);
    }
  }
  .carousel-control-next-icon {
    transform: rotate(180deg);
  }
}
.controls {
  min-width: 50px;
}
.quote-block {
  min-height: 250px;
}
</style>
